export const QA_NAME_GRETA_AI_CHAT_SOURCE_PICKER_CARD =
  'gretaAIChatSourcePickerCard'
